import { formatAddressParts } from "../../../../../helpers/StringHelper";
import AdobeComboBox from "../../../../AdobeAriaLib/AdobeComboBox";
import { IOption } from "../../../../AdobeAriaLib/AdobeSelect";
import { IAddress } from "./FormAddress";

interface IFormAddressSelector {
    value: string | undefined,
    label: string
    required: boolean
    onChange: Function,
    options: IOption[],
    addresses: Map<string, IAddress>,
    validateRule?: Function,
    validationError?: string
}

export default function FormAddressSelector({ value, label, options, addresses, required, onChange, validateRule, validationError }: IFormAddressSelector) {

    function handleChange(val: string) {
        onChange(val)
    }

    function displaySelectedAddress() {
        if (value && options) {
            const option = options.find((x: any) => x.value === value) as any;
            if (option?.value) {
                const addressToDisplay = addresses.get(option.value);
                const parts = formatAddressParts(addressToDisplay);
                return <p className="address-selector__address-info">{parts.join(', ')}</p>
            }
        }
    }

    return (
        <div className="address-selector__wrapper">
            <AdobeComboBox
                value={value}
                label={label}
                labelVisible={true}
                options={options}
                required={required}
                onChangeSelect={handleChange}
                disabled={false}
                selectionMode="single"
                validateRule={validateRule}
                validationError={validationError} />
            {value &&
                <div>
                    {displaySelectedAddress()}
                </div>
            }
        </div>
    )
}